// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css'


//引入
// import store from './store'
Vue.prototype.$bus = new Vue()
import VueSocketIO from 'vue-socket.io'
let hostname=window.location.hostname
let userId = JSON.parse(localStorage.getItem("Admin-Data")) ? JSON.parse(localStorage.getItem("Admin-Data")).userId : '';
Vue.use(new VueSocketIO({
  debug: true,
//   connection: `ws://172.16.3.221:9009?userId=${userId}`,
  connection: `?userId=${userId}`,
// connection: `/socketIo?userId=${userId}`,

  options:{
    // 在指定页面再开启
    autoConnect: false,
    reconnect: true,
    reconnectionAttempts: 3 // 重连次数
  },
  // connection: `http://172.16.2.48/socket.io?userId=294723028728676352&topic=workflow`
}))

// import SocketIO from "socket.io-client"
// import VueSocketIO from 'vue-socket.io'
// let userId = JSON.parse(localStorage.getItem("Admin-Data")) ? JSON.parse(localStorage.getItem("Admin-Data")).userId : '';
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: `/socket.io?userId=${userId}&topic=workflow`,
// }))

import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import splitPane from 'vue-splitpane'

import baseConfig from '../config/base-config'

import './js/axios.js'
import x2js from 'x2js' //xml数据处理插件

// 引入echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;


axios.defaults.crossDomain = true
axios.defaults.withCredentials = true;
Vue.prototype.$x2js = new x2js()
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
//Vue.prototype.$appId = 'JXXM'
Vue.prototype.$idmConfig = baseConfig
Vue.config.productionTip = false
Vue.use(ElementUi)
Vue.component('split-pane', splitPane);
// router.beforeEach((to, form, next) => {
//   if (to.meta.requireAuth) {
//     if (sessionStorage.getItem("logined") !== null) {
//       next()
//     } else {
//       next('/')
//     }
//   } else {
//     next()
//   }
// })
import  VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {orgPeopleComponents2} from 'front-ui';
Vue.use(orgPeopleComponents2)
// 引入vue-amap
// import AMap from 'vue-amap';
// Vue.use(AMap);

import '../static/icon-common2/iconfont.css'

// 初始化vue-amap
// AMap.initAMapApiLoader({
//   // 高德的key
//   key: 'f45940514c4a0bcdb99ca37d9a84e4ac',
//   // 插件集合 （插件按需引入）
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
// });

// font-ui
import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree)

import funcUtil from './utils/funcUtil'
Vue.prototype.$funcUtil = funcUtil

//定义中央事件总线
const EventBus = new Vue();
// 将中央事件总线赋值到 Vue.prototype 上，这样所有组件都能访问到了
Vue.prototype.$EventBus = EventBus;

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js